// pages/Contact.js
import React, { useState } from 'react';
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaPaperPlane } from 'react-icons/fa';
import './Contact.css';
import emailjs from "@emailjs/browser";
import { toast } from "react-toastify";
const Contact = ({ budgetData }) => {
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        company: '',
        projectType: 'website',
        budget: budgetData.total || '',
        timeline: '',
        message: ''
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            await emailjs.send(
                "service_e02bh6a",
                "template_kz61d2a",
                formData,
                "HbOT-KJf4D7W3jtGN"
            );

            toast.success("✅ Message sent successfully!");

            // Reset form
            setFormData({
                name: '',
                email: '',
                phone: '',
                company: '',
                projectType: 'website',
                budget: '',
                timeline: '',
                message: ''
            });

        } catch (error) {
            console.error(error);
            toast.error("❌ Failed to send message. Please try again.");
        }

        setLoading(false);
    };
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    return (
        <section id="contact" className="section contact">
            <div className="animated-bg">
                <div className="bg-grid"></div>
            </div>

            <div className="container">
                <div className="section-header">
                    <h2 className="section-title">Let's Start Your Project</h2>
                    <p className="section-subtitle">
                        Get a free consultation and detailed proposal for your website project
                    </p>
                </div>

                <div className="contact-container">
                    <div className="contact-info card">
                        <h3>Get in Touch</h3>

                        <div className="contact-details">
                            <div className="contact-item">
                                <div className="contact-icon">
                                    <FaPhone />
                                </div>
                                <div>
                                    <h4>Call Us</h4>
                                    <p>+92 3098373032</p>
                                    <p>Mon-Fri, 9am-6pm EST</p>
                                </div>
                            </div>

                            <div className="contact-item">
                                <div className="contact-icon">
                                    <FaEnvelope />
                                </div>
                                <div>
                                    <h4>Email Us</h4>
                                    <p>talhagul70@gmail.com</p>
                                    <p>sales@gforcesolutions.com</p>
                                </div>
                            </div>

                            <div className="contact-item">
                                <div className="contact-icon">
                                    <FaMapMarkerAlt />
                                </div>
                                <div>
                                    <h4>Visit Us</h4>
                                    <p>Qadari colony walton lahore</p>
                                    {/* <p>San Francisco, CA 94107</p> */}
                                </div>
                            </div>
                        </div>

                        <div className="contact-features">
                            <h4>Why Choose Us</h4>
                            <ul>
                                <li>24/7 Customer Support</li>
                                <li>100% Satisfaction Guarantee</li>
                                <li>6-Month Free Maintenance</li>
                                <li>On-time Delivery</li>
                                <li>Transparent Pricing</li>
                                <li>Agile Development Process</li>
                            </ul>
                        </div>
                    </div>

                    <div className="contact-form card">
                        {budgetData.total > 0 && (
                            <div className="budget-summary-alert">
                                <h4>Your Calculated Budget: ${budgetData.total}</h4>
                                <p>We'll prepare a detailed proposal based on your selections</p>
                            </div>
                        )}

                        <form onSubmit={handleSubmit}>
                            <div className="form-row">
                                <div className="form-group">
                                    <label htmlFor="name">Full Name *</label>
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="email">Email Address *</label>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group">
                                    <label htmlFor="phone">Phone Number</label>
                                    <input
                                        type="tel"
                                        id="phone"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="company">Company Name</label>
                                    <input
                                        type="text"
                                        id="company"
                                        name="company"
                                        value={formData.company}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group">
                                    <label htmlFor="projectType">Project Type *</label>
                                    <select
                                        id="projectType"
                                        name="projectType"
                                        value={formData.projectType}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="crm">SaaS / CRM Development</option>
                                        <option value="website">Website Development</option>
                                        <option value="ecommerce">E-commerce Store</option>
                                        <option value="webapp">Web Application</option>
                                        <option value="redesign">Website Redesign</option>
                                        <option value="maintenance">Website Maintenance</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="budget">Estimated Budget *</label>
                                    <select
                                        id="budget"
                                        name="budget"
                                        value={formData.budget}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Select Budget Range</option>
                                        <option value="1000-5000">$1,000 - $5,000</option>
                                        <option value="5000-10000">$5,000 - $10,000</option>
                                        <option value="10000-25000">$10,000 - $25,000</option>
                                        <option value="25000+">$25,000+</option>
                                        {budgetData.total > 0 && (
                                            <option value={budgetData.total}>${budgetData.total} (Calculated)</option>
                                        )}
                                    </select>
                                </div>
                            </div>

                            <div className="form-group">
                                <label htmlFor="timeline">Project Timeline</label>
                                <select
                                    id="timeline"
                                    name="timeline"
                                    value={formData.timeline}
                                    onChange={handleChange}
                                >
                                    <option value="">Select Timeline</option>
                                    <option value="urgent">Urgent (2-3 weeks)</option>
                                    <option value="standard">Standard (4-6 weeks)</option>
                                    <option value="flexible">Flexible (2-3 months)</option>
                                </select>
                            </div>

                            <div className="form-group">
                                <label htmlFor="message">Project Details *</label>
                                <textarea
                                    id="message"
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    rows="5"
                                    placeholder="Tell us about your project requirements, goals, and any specific features you need..."
                                    required
                                ></textarea>
                            </div>

                            <div className="form-submit">
                                <button type="submit" className="btn" disabled={loading}>
                                    {loading ? (
                                        <>
                                            <span className="spinner"></span> Sending...
                                        </>
                                    ) : (
                                        <>
                                            <FaPaperPlane /> Send Message
                                        </>
                                    )}
                                </button>
                                <p className="form-note">
                                    We'll respond within 24 hours with a detailed proposal
                                </p>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contact;